import "./style.css";
import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { c as i } from "../../__shared__/index.js";
const b = "_thumbnail_18ukb_1", h = "_selected_18ukb_29", f = "_wrapper_18ukb_33", v = "_image_18ukb_44", y = "_dot_18ukb_57", e = {
  thumbnail: b,
  selected: h,
  wrapper: f,
  image: v,
  dot: y
};
function N({
  url: n,
  title: l,
  imageUrl: s,
  imageAltText: o,
  isCurrentPage: t,
  className: u,
  hasDot: _,
  productId: c,
  ...d
}) {
  return /* @__PURE__ */ p(
    "li",
    {
      ...d,
      className: i(u, e.thumbnail, {
        [e.selected]: t
      }),
      "aria-current": t ? "page" : void 0,
      children: [
        _ ? /* @__PURE__ */ a(
          "span",
          {
            "aria-labelledby": c ? `offers-from-dot-${c}` : void 0,
            className: e.dot
          }
        ) : null,
        t ? /* @__PURE__ */ a("span", { className: e.wrapper, title: l, children: /* @__PURE__ */ a(r, { imageUrl: s, imageAltText: o }) }) : /* @__PURE__ */ a(
          "a",
          {
            className: e.wrapper,
            href: n,
            title: l,
            "aria-label": l,
            children: /* @__PURE__ */ a(r, { imageUrl: s, imageAltText: o })
          }
        )
      ]
    }
  );
}
function r({ imageUrl: n, imageAltText: l }) {
  return /* @__PURE__ */ a(
    "img",
    {
      loading: "lazy",
      src: n,
      alt: l,
      className: e.image
    }
  );
}
const k = "_nav_1ltlt_1", w = "_layout_1ltlt_5", m = {
  nav: k,
  layout: w
};
function g({
  children: n,
  className: l,
  ...s
}) {
  return /* @__PURE__ */ a("nav", { ...s, className: i(
    m.nav,
    l
  ), children: /* @__PURE__ */ a("ul", { className: m.layout, children: n }) });
}
g.Thumbnail = N;
export {
  g as default
};
//# sourceMappingURL=ThumbnailNav.js.map
